import React, { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { customerWa } from "@/lib/customerMsg";

const inp = "h-9 px-3 rounded-lg border border-[#E5E0D8] text-sm bg-white";

const jobMsg = (b, url) => `Naya CHELA job (PAID)\n\ud83d\udc64 ${b.name}\n\ud83e\uddf0 ${b.service}\n\ud83d\udcc5 ${b.date} ${b.time} \u00b7 ${b.duration}\n\ud83c\udfe0 ${b.location || "-"}\n\nJob details, map aur "Job done" button:\n${url}`;

export default function AssignJob({ b, workers, onAssigned }) {
  const [name, setName] = useState(b.worker_name || "");
  const [phone, setPhone] = useState((b.worker_phone || "").replace(/^\+?91/, ""));
  const [busy, setBusy] = useState(false);
  const url = b.job_token ? `${window.location.origin}/job/${b.job_token}` : "";

  const pick = (e) => {
    const w = workers.find((x) => x.id === e.target.value);
    if (w) { setName(w.name); setPhone((w.whatsapp || "").replace(/\D/g, "").slice(-10)); }
  };
  const assign = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/admin/bookings/${b.id}/job`, { worker_name: name, worker_phone: phone });
      onAssigned(b.id, data);
      toast.success("CHELA assigned. Now send the job on WhatsApp.");
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail) || "Could not assign"); } finally { setBusy(false); }
  };

  return (
    <div data-testid={`assign-job-${b.id}`} className="mt-3 rounded-xl border border-[#E5E0D8] bg-[#FAF8F5] p-3 space-y-2">
      <div className="text-xs font-bold text-[#121316]">Assign CHELA {b.job_status && <span className="ml-1 px-2 py-0.5 rounded-full bg-[#121316] text-white uppercase">{b.job_status}</span>}</div>
      <div className="flex flex-wrap gap-2">
        {workers.length > 0 && (
          <select data-testid={`assign-pick-${b.id}`} onChange={pick} defaultValue="" className={inp}>
            <option value="">Pick from applicants…</option>
            {workers.map((w) => <option key={w.id} value={w.id}>{w.name} ({w.whatsapp})</option>)}
          </select>
        )}
        <input data-testid={`assign-name-${b.id}`} value={name} onChange={(e) => setName(e.target.value)} placeholder="CHELA name" className={inp} />
        <input data-testid={`assign-phone-${b.id}`} value={phone} onChange={(e) => setPhone(e.target.value.replace(/\D/g, "").slice(0, 10))} placeholder="WhatsApp (10 digits)" className={inp} />
        <button data-testid={`assign-save-${b.id}`} onClick={assign} disabled={busy} className="h-9 px-4 rounded-full bg-[#121316] text-white text-xs font-bold disabled:opacity-60">{b.job_token ? "Update" : "Assign"}</button>
      </div>
      {url && (
        <div className="flex flex-wrap items-center gap-2">
          <a data-testid={`assign-send-wa-${b.id}`} target="_blank" rel="noreferrer" href={`https://wa.me/91${phone}?text=${encodeURIComponent(jobMsg(b, url))}`} className="text-xs font-bold px-3 py-1.5 rounded-full bg-[#25D366] text-white">Send job to {name || "CHELA"} on WhatsApp</a>
          <button data-testid={`assign-copy-${b.id}`} onClick={() => { navigator.clipboard?.writeText(url); toast.success("Job link copied"); }} className="text-xs font-bold px-3 py-1.5 rounded-full border border-[#E5E0D8] bg-white">Copy job link</button>
          <a data-testid={`assign-open-${b.id}`} href={url} target="_blank" rel="noreferrer" className="text-xs font-bold underline text-[#E05624]">Open job page</a>
        </div>
      )}
      {url && (
        <div className="flex flex-wrap items-center gap-2">
          <span className="text-xs font-bold text-[#5A5D65]">Message customer:</span>
          <a data-testid={`customer-reached-${b.id}`} target="_blank" rel="noreferrer" href={customerWa("reached", { ...b, worker_name: name, ref: b.id.slice(-6).toUpperCase() })} className="text-xs font-bold px-3 py-1.5 rounded-full border border-[#25D366] text-[#1B8A4B] bg-white">CHELA reached</a>
          <a data-testid={`customer-done-${b.id}`} target="_blank" rel="noreferrer" href={customerWa("done", { ...b, worker_name: name, ref: b.id.slice(-6).toUpperCase() })} className="text-xs font-bold px-3 py-1.5 rounded-full border border-[#25D366] text-[#1B8A4B] bg-white">Job done</a>
        </div>
      )}
    </div>
  );
}
